import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import { UserAuth } from '../context/AuthContext';
import { db } from "../firebase";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { useMediaQuery } from 'react-responsive';
import OnePurchase from './OnePurchase';
import '../setupapp/setup.css'; // Use the V2 redesign styles

const Account = () => {
    const buttonsData = [
        "Purchase History",
        "Downloads",
        "Password and Security",
        "Account Settings"
    ];
    const [allOwnedProducts, setAllOwnedProducts] = useState([]);
    const [selected, setSelected] = useState(buttonsData[0]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const { user, deleteUser } = UserAuth();

    const handleDelete = () => {
        if (deleteUser) {
            deleteUser();
        } else {
            console.warn("Delete account not implemented in context");
        }
    };

    const Buttons = () => {
        return (
            <div className="setup-pill-nav">
                {buttonsData.map((button, index) => (
                    <button
                        key={index}
                        className={`setup-pill-btn ${button === selected ? 'active' : ''}`}
                        onClick={() => setSelected(button)}
                    >
                        {button}
                    </button>
                ))}
            </div>
        );
    };

    const Dropdown = () => (
        <select
            className="setup-input"
            value={selected}
            onChange={(e) => setSelected(e.target.value)}
            style={{ marginBottom: '32px', cursor: 'pointer' }}
        >
            {buttonsData.map((option, index) => (
                <option key={index} value={option} style={{ background: '#111', color: '#fff' }}>{option}</option>
            ))}
        </select>
    );

    const ResponsiveButtons = () => {
        const isSmallScreen = useMediaQuery({ query: '(max-width: 768px)' });
        return isSmallScreen ? <Dropdown /> : <Buttons />;
    };

    //fetch purchased products
    useEffect(() => {
        if (user && user.uid) {
            const q = query(collection(db, "purchasedProducts"), where("user", "==", user.uid));
            onSnapshot(q, (snapshot) => {
                setAllOwnedProducts(snapshot.docs.map(doc => {
                    return {
                        id: doc.id,
                        viewing: false,
                        ...doc.data()
                    }
                }))
            });
        }
    }, [user]);

    return (
        <div className="setup-app-container setup-page-with-header" style={{ display: 'block', paddingTop: '300px', paddingBottom: '120px', overflowY: 'auto' }}>
            {/* The V2 glass panel acting as the main dashboard wrapper */}
            <motion.div
                className="setup-glass-panel"
                initial={{ opacity: 0, scale: 0.95, y: 20 }} 
                animate={{ opacity: 1, scale: 1, y: 0 }}
                transition={{ duration: 0.6, type: "spring", bounce: 0.2 }}
                style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'left', padding: '40px' }}
            >
                <motion.div
                    initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}
                    style={{ marginBottom: '32px' }}
                >
                    <h1 className="setup-header" style={{ fontSize: '28px', textAlign: 'left', marginBottom: '8px' }}>
                        Account Dashboard
                    </h1>
                    <p className="setup-subtitle" style={{ textAlign: 'left', margin: 0 }}>
                        {user?.email}
                    </p>
                </motion.div>

                <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}>
                    <ResponsiveButtons />
                </motion.div>

                <AnimatePresence mode="wait">
                    <motion.div
                        key={selected}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        transition={{ duration: 0.3 }}
                        style={{ minHeight: '300px' }}
                    >
                        {selected === "Purchase History" && (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                {allOwnedProducts.length > 0 ? (
                                    allOwnedProducts.map((element) => (
                                        <OnePurchase key={element.id} name={element.name} id={element.id} time={element.time} />
                                    ))
                                ) : (
                                    <div style={{ color: '#888', textAlign: 'center', padding: '40px', background: 'rgba(0,0,0,0.2)', borderRadius: '16px', border: '1px solid rgba(255,255,255,0.05)' }}>
                                        No purchase history found.
                                    </div>
                                )}
                            </div>
                        )}

                        {selected === "Downloads" && (
                            <div style={{ color: '#888', textAlign: 'center', padding: '40px', background: 'rgba(0,0,0,0.2)', borderRadius: '16px', border: '1px solid rgba(255,255,255,0.05)' }}>
                                Downloads will appear here.
                            </div>
                        )}

                        {selected === "Password and Security" && (
                            <div style={{ color: '#888', textAlign: 'center', padding: '40px', background: 'rgba(0,0,0,0.2)', borderRadius: '16px', border: '1px solid rgba(255,255,255,0.05)' }}>
                                Password settings are coming soon.
                            </div>
                        )}

                        {selected === "Account Settings" && (
                            <div style={{ padding: '24px', background: 'rgba(255,68,68,0.05)', borderRadius: '16px', border: '1px solid rgba(255,68,68,0.1)' }}>
                                <h3 style={{ color: '#fff', margin: '0 0 16px 0', fontSize: '18px' }}>Danger Zone</h3>
                                <p style={{ color: '#888', fontSize: '14px', marginBottom: '24px' }}>Once you delete your account, there is no going back. Please be certain.</p>
                                <button className="setup-btn-primary" onClick={() => setShowDeleteModal(true)} style={{ background: 'linear-gradient(180deg, #ff4444 0%, #cc0000 100%)', boxShadow: 'inset 0 1px 1px rgba(255,255,255,0.3), inset 0 -2px 4px rgba(0,0,0,0.4)', width: 'auto', padding: '12px 24px' }}>
                                    Delete Account
                                </button>
                            </div>
                        )}
                    </motion.div>
                </AnimatePresence>
            </motion.div>

            {/* Custom Delete Confirmation Modal */}
            <AnimatePresence>
                {showDeleteModal && (
                    <motion.div 
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        style={{
                            position: 'fixed',
                            top: 0, left: 0, width: '100vw', height: '100vh',
                            background: 'rgba(0,0,0,0.85)',
                            backdropFilter: 'blur(10px)',
                            zIndex: 999999,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        <motion.div
                            initial={{ scale: 0.9, y: 20 }}
                            animate={{ scale: 1, y: 0 }}
                            exit={{ scale: 0.9, y: 20 }}
                            transition={{ type: "spring", bounce: 0.4 }}
                            style={{
                                background: '#111',
                                border: '1px solid rgba(255,68,68,0.4)',
                                borderRadius: '24px',
                                padding: '40px',
                                maxWidth: '400px',
                                width: '90%',
                                textAlign: 'center',
                                boxShadow: '0 20px 50px rgba(0,0,0,0.8), 0 0 0 1px rgba(255,68,68,0.1) inset'
                            }}
                        >
                            <h2 style={{ color: '#ff4444', marginTop: 0, marginBottom: '16px', fontSize: '24px', fontFamily: '"Avenir Black", sans-serif' }}>
                                Destroy Account?
                            </h2>
                            <p style={{ color: '#aaa', fontSize: '15px', lineHeight: 1.6, marginBottom: '32px' }}>
                                Are you absolutely sure? This will permanently wipe your data. <strong style={{color: '#fff'}}>You will immediately lose access to all of your plugin licenses</strong>, and your purchase history will be destroyed. This action cannot be undone.
                            </p>
                            
                            <div style={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
                                <button 
                                    className="setup-btn-primary" 
                                    onClick={handleDelete}
                                    style={{ 
                                        background: '#ff4444', 
                                        color: '#fff', 
                                        padding: '16px', 
                                        border: 'none', 
                                        borderRadius: '12px', 
                                        fontWeight: 'bold', 
                                        cursor: 'pointer' 
                                    }}
                                >
                                    Yes, destroy my data
                                </button>
                                <button 
                                    onClick={() => setShowDeleteModal(false)}
                                    style={{ 
                                        background: 'transparent', 
                                        color: '#888', 
                                        padding: '16px', 
                                        border: '1px solid rgba(255,255,255,0.1)', 
                                        borderRadius: '12px', 
                                        fontWeight: 'bold', 
                                        cursor: 'pointer',
                                        transition: 'background 0.2s'
                                    }}
                                    onMouseOver={(e) => e.target.style.background = 'rgba(255,255,255,0.05)'}
                                    onMouseOut={(e) => e.target.style.background = 'transparent'}
                                >
                                    Cancel
                                </button>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default Account;